export default __webpack_public_path__ + "static/media/filter.c029b46a.svg";